import { CustomerSegment, CustomerSubjectType } from 'generated/bffCustomer/models';
import { CustomerInfo } from 'models/context/CustomerInfo';

export const isUnidentifiedResidentCustomer = (customer: CustomerInfo | null) =>
  customer?.segment === CustomerSegment.R && customer?.subjectType === CustomerSubjectType.Unidentified;
